import { History } from "history";
import React, { FunctionComponent, ReactNode, useEffect, useMemo, useState } from "react";
import { IntlProvider } from "react-intl";
import { getMessages } from "@Locales/index";
import { Locale } from "@Locales/index";
import { locationToLocalization } from "@Locales/localizationMapping";

interface Props {
  children: ReactNode;
  history: History;
}

const WithLocale: FunctionComponent<Props> = ({ children, history }) => {
  const initialLocale = locationToLocalization(window.location).locale;
  const [locale, setLocale] = useState<Locale>(initialLocale);
  useEffect(() => {
    const unlisten = history.listen(({ location }) => {
      setLocale(locationToLocalization({ pathname: location.pathname }).locale);
    });

    return () => unlisten();
  }, [history, setLocale]);

  const messages = useMemo(() => {
    return getMessages(locale);
  }, [locale]);

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export default WithLocale;
